import { render, staticRenderFns } from "./editPaxelRecycleReason.vue?vue&type=template&id=c2d9fe38&"
import script from "./editPaxelRecycleReason.vue?vue&type=script&lang=js&"
export * from "./editPaxelRecycleReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports